<template>
  <div class="footer-wrapper text-center">
    <div class="footer-container">
      <div class="footer-content">
        <!-- <h3 class="title">Getting Started</h3>
        <div class="link-content d-flex justify-content-between">
          <a href="#">Sell your items</a>
          <a href="#">How to buy items</a>
          <a href="#">Create your own NFT</a>
        </div>
        <primary-button class="footer-btn">
          <i class="icon-help" /> Explore Help Center
        </primary-button> -->
        <div class="community">
          <div class="title">Community</div>
          <div class="icons">
            <a
              class="community-icon"
              href="https://twitter.com/bunicornswap"
              target="_blank"
            >
              <img src="@/assets/icon/twitter.png" />
            </a>
            <a
              class="community-icon"
              href="https://t.me/bunicornswap_en"
              target="_blank"
            >
              <img src="@/assets/icon/telegram.png" />
            </a>
            <a
              class="community-icon"
              href="https://discord.com/invite/Jfa5eebPJs"
              target="_blank"
            >
              <img src="@/assets/icon/discord-large.png" />
            </a>
            <a
              class="community-icon"
              href="https://bunicornswap.medium.com"
              target="_blank"
            >
              <img src="@/assets/icon/medium-lagre.png" />
            </a>

            <a
              class="community-icon"
              href="https://forum.buni.finance/"
              target="_blank"
            >
              <img src="@/assets/icon/chat.png" />
            </a>
          </div>
        </div>
      </div>
      <div class="copy-right">© All right reserved by Bunicorn 2021.</div>
    </div>
  </div>
</template>
<script>
// import PrimaryButton from "@/components/BaseComponents/PrimaryButton.vue";

export default {
  // components: { PrimaryButton },
};
</script>

<style lang="scss" scoped>
@import './../assets/style/variables.scss';

.footer-wrapper {
  width: 100%;
  background: #2c4a68;

  .footer-container {
    background-image: url(./../assets/images/footer.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;

    height: 100%;
    width: 100%;

    .footer-content {
      padding: 30px 0 30px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      .community {
        .title {
          font-size: 24px;
          font-family: Inter-Bold;
          color: #fff;
        }
        .icons {
          margin-top: 10px;
          display: flex;
          .community-icon {
            margin-right: 12px;
            cursor: pointer;
            img {
              width: 40px;
              height: 40px;
              object-fit: contain;
            }
          }
        }
      }
      .footer-btn {
        margin-top: 40px;
        .icon-help {
          font-size: 14px;
          margin-right: 4px;
        }
      }
      .title {
        font-size: 36px;
        font-weight: 700;
        line-height: 42px;
        color: #ffffff;
        margin-bottom: 40px;
      }
      .link-content {
        font-size: 16px;
        line-height: 24px;
        font-weight: 600;
        max-width: 700px;
        margin: auto;
        flex-wrap: wrap;
        a {
          width: 180px;
          color: #828c9f;
          &:hover {
            color: #ffffff;
          }
        }
      }
    }

    .copy-right {
      color: #828c9f;
      width: 100%;
      font-size: 14px;
      line-height: 48px;
      border-top: 2px solid #36597c;
    }
  }
}
@media screen and (max-width: $breakpoint-desktop) {
  .footer-wrapper {
    .footer-container {
      .footer-content {
        padding: 16px 0;
        .title {
          font-size: 24px;
          margin-bottom: 8px;
        }
        .link-content {
          flex-direction: column;
          align-items: center;
          a {
            margin: 4px 0;
          }
        }
        .footer-btn {
          margin-top: 16px;
        }
      }
    }
  }
}
</style>
